// extracted by mini-css-extract-plugin
export default {"title":"TuwyEligibility_title__cWRbg","description":"TuwyEligibility_description__PmnNT"};